import { useMutation } from "@tanstack/react-query";

import { sendUserFeedbacks } from "./infra/sendUserFeedbacks.api";

export const useSendUserFeedback = () => {
  const mutation = useMutation({
    mutationFn: sendUserFeedbacks,
  });

  return { sendUserFeedbacks: mutation.mutate, ...mutation };
};
